class FormatHandData {
  constructor(d, handRareData) {
    this.activeItem = d;
    this.handRareData = handRareData;
    this.formatData2()
  }
  handRareData = [];
  confidenceProportion = 1.1; //置信度最低显视比例 超出1时不显示百分比文字
  confidenceProportionRed = 0.7; //高亮红显置信度最低显视比例
  isTextRed = false; //是否高亮红显
  showMoreList = false; //是否显示更多
  xh = [
    "①",
    "②",
    "③",
    "④",
    "⑤",
    "⑥",
    "⑦",
    "⑧",
    "⑨",
    "⑩",
    "⑪",
    "⑫",
    "⑬",
    "⑭",
    "⑮",
    "⑯",
    "⑰",
    "⑱",
    "⑲",
    "⑳",
    "㉑",
    "㉒",
    "㉓",
    "㉔",
    "㉕",
    "㉖",
    "㉗",
    "㉘",
    "㉙",
    "㉚",
    "㉛",
    "㉜",
    "㉝",
    "㉞",
    "㉟",
    "㊱",
    "㊲",
    "㊳",
    "㊴",
    "㊵",
    "㊶",
    "㊷",
    "㊸",
    "㊹",
    "㊺",
    "㊻",
    "㊼",
    "㊽",
    "㊾",
    "㊿",
  ];
  infoList = [];
  unscrambleList = {};
  // 解读来源 1健康 2 婚姻 3 家庭 4 财富 5 事业 6 其他
  infoList2 = [
    {
      icon: "icon-xunhuan",
      title: "健康",
      value: [],
      id: 1,
      active: true,
      isShow: false,
    },
    {
      icon: "icon-hunyinzhuangkuangbiangeng",
      title: "婚姻",
      value: [],
      id: 2,
      active: false,
      isShow: false,
    },
    {
      icon: "icon-home1",
      title: "家庭",
      value: [],
      id: 3,
      active: false,
      isShow: false,
    },
    {
      icon: "icon-qianbao",
      title: "财富",
      value: [],
      id: 4,
      active: false,
      isShow: false,
    },
    {
      icon: "icon-renshiyewu",
      title: "事业",
      value: [],
      id: 5,
      active: false,
      isShow: false,
    },
    {
      icon: "icon-qita",
      title: "其他",
      value: [],
      id: 6,
      active: false,
      isShow: false,
    },
  ];
  handData = {};
  activeItem = {};
  medicalRecordScan = [];
  newlineToBr(str) {
    if (str) return str.replace(/\n/g, "<br>");
  };

  // 按指定字段对对象数组分组
  groupBy(array, key) {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, {});
  };

  reset() {
    this.unscrambleList = {};
    this.unscrambleColorList = {};
    this.infoList2.forEach((i) => {
      i.value = [];
      i.isShow = false;
    });
  };

  // 按一定长度切数组成多个数组
  chunkArray(array, chunkSize) {
    if (array.length === 0) {
      return [];
    }
    const chunk = array.splice(0, chunkSize);
    return [chunk].concat(this.chunkArray(array, chunkSize));
  };

  // 新版本格式化数据
  formatData2() {
    this.isLogin = false;
    this.reset();

    let obj = {
      graphical: [], //图形
      texture: [], //纹路
      speckle: [], //斑点
      ninePoint: [], //九区中点和名称
      finger: [], //手指数据
      qingjin: [], // 青筋
      version: 2, // 版本
    };

    // 整理区块名称和区块中心点坐标
    let nine = this.activeItem.nineHillsPlains;
    obj.ninePoint = nine
      .filter((i) => i.regionName)
      .map((i) => {
        let p = i.graphical.coordinate;
        let point = [
          p.reduce((sum, j) => {
            return (sum += j[0]);
          }, 0) / p.length,
          p.reduce((sum, j) => {
            return (sum += j[1]);
          }, 0) / p.length,
        ];
        return {
          label: i.regionName,
          point,
        };
      });

    this.setPoint2(this.activeItem, obj);

    /*
    obj.threeMainLine = [];
    let handLine = this.activeItem.handLine;

    // 三大主线
    handLine.forEach((i) => {
      let arr = i.graphical.metadata;

      // 找断点
      let indexs = [];
      arr.forEach((j, index) => {
        if (j.breakPointFlag) {
          indexs.push(index);
        }
      });
      indexs.unshift(0);
      indexs.push(arr.length - 1);
      let arr3 = this.chunkArray(indexs, 2); //按长度为2切割数组
      arr3.forEach((i) => {
        let list = arr.slice(i[0], i[1] + 1);
        let points = list
          .filter((j) => j.splitObjIndex == -1)
          .map((i) => i.coordinate);

        obj.threeMainLine.push({
          text: i.lineName,
          points,
        });
      });
    });

    // 分支线
    handLine.forEach((i) => {
      let list = i.graphical.metadata;
      // 1、先找到分叉点，即branchpointflg为true的
      let list2 = list.filter(
        (j) => j.branchPointFlag && j.splitObjIndex == -1
      );
      // 找到所有分叉线上的点，即splitobjindex不等于-1的
      let list3 = list.filter((j) => j.splitObjIndex != -1);
      let g = [];
      list2.filter((i) => {
        let arr = list3.filter(
          (j) => j.parentPointIndex == i.branchPointIndex
        );
        let o = this.groupBy(arr, "splitObjIndex");
        for (const key in o) {
          if (Object.hasOwnProperty.call(o, key)) {
            let l = o[key];
            // l.unshift(i)
            g.push(l);
          }
        }
      });
      g.forEach((j) => {
        let points = j.map((i) => i.coordinate);
        obj.threeMainLine.push({
          text: "",
          points,
        });
      });
    });

    // 青筋
    if (this.activeItem.palm) {
      this.activeItem.palm.qingjin.forEach((j) => {
        let str = this.formatUnscramble(j.privateUnscrambles);
        obj.qingjin.push({
          text: str ? "青筋：" + str : "青筋",
          points: j.graphical.coordinate,
        });
      });
    }

    // 添加手指数据
    this.activeItem.finger.forEach((i) => {
      i.jointWrinkle.forEach((j) => {
        obj.finger.push({
          text: "",
          points: j.graphical.coordinate,
          // isFinger: true, // 是指节纹
        });
      });
    });

    Object.assign(obj, {
      base64: this.activeItem.base64,
      imageHeight: this.imageHeight || this.palmDeviceSize.width,
      imageWidth: this.imageWidth || this.palmDeviceSize.height,
    });
    if (this.hander) this.hander.setData(obj);
    this.showInfo = true;
    this.showZoomBtn = true;
    */
  };

  // nb 置信度  isRed 是否红色
  round(nb, isRed) {
    return nb && nb >= this.confidenceProportion
      ? isRed
        ? `<i>(${Math.round(nb * 100)}%)</i>`
        : `(${Math.round(nb * 100)}%)`
      : "";
  };

  // 把内容里的 "1、2、"换成 "①②", isClearGroupTag 是否清除分组标签
  formatSerialNumber(str, isClearGroupTag = false) {
    let m = str.match(/\[\w+\d+\]/gi); //把分组号提取出来
    if (m) str = str.replace(m[0], "");
    str = str.replace(/\[(\p{sc=Han}+)\]/gu, ""); //去除[身体系统名称]
    str =
      str && /\d+[、]/.test(str)
        ? str
          .split(/\d+[、]/gi)
          .filter((item) => item)
          .map((item, index) => this.xh[index] + item)
          .join(" ")
        : str;
    str = this.addRareText(str);
    return isClearGroupTag ? str : m ? m + str : str;
  };

  addRareText(str) {
    this.handRareData.forEach((item) => {
      if (
        str.replace(/[。，、\n\t]/g, "") ==
        item.label.replace(/[。，、\n\t]/g, "")
      ) {
        str = `<div class="rare-text">
            <span class="r-t-label">稀有(${item.string2}%)<i>此词条在全体用户中仅占约${item.string2}%</i></span>
            <span><i class="xszy-icon icon-xingxing"></i>${item.label}<i class="xszy-icon icon-xingxing"></i></span>
          </div>`;
      }
    });
    return str;
  };

  setUnscrambleStr(i) {
    i.unscrambleStr = this.addRed(
      this.formatSerialNumber(i.unscramble) + this.round(i.confidence, true),
      i.confidence
    );
    return i;
  };

  cloneObj(data) {
    var E = JSON.stringify(data);
    return E = eval("(" + E + ")")
  };

  // isOtherPalmUnscrambles 是否其它掌形数据
  setUnscrambleList(list, isOtherPalmUnscrambles) {
    if (!list) return;
    list.forEach((i) => {
      if (i.unscrambleResource != 1) {
        this.setUnscrambleListFun(i, isOtherPalmUnscrambles);
      } else {
        let arr = i.unscramble.split(/\d+、/).filter((item) => item);
        let objList = arr.map((j) => {
          let o = this.cloneObj(i);
          o.unscramble = j;
          o.weight = o.confidence / arr.length;
          return o;
        });
        objList.forEach((j) => {
          this.setUnscrambleListFun(j, isOtherPalmUnscrambles);
        });
      }
    });
  };

  // 删除[***]然后比较是否重复
  removeGroupNameStr(str) {
    return str.replace(/\[.*?\]/g, "").trim();
  };

  setUnscrambleListFun(i, isOtherPalmUnscrambles) {
    let arr = this.unscrambleList[i.unscrambleResource];
    let confidence =
      i.confidence && i.confidence.length ? i.confidence[0] : 0;
    let obj = {
      unscramble: i.unscramble,
      unscrambleType: i.unscrambleType,
      unscrambleStr: "",
      confidence,
      weight: i.weight || confidence, // 权重后续用于排序
    };
    if (i.unscrambleResource != 1 || i.unscrambleType == 4) {
      obj.unscramble = obj.unscramble.replace(/\[(\p{sc=Han}+)\]/gu, ""); //去除[身体系统名称]
      this.setUnscrambleStr(obj);
    }
    if (i.unscrambleType == 4) {
      let findIndex = this.colorList.findIndex(
        (item) =>
          this.removeGroupNameStr(item.unscramble) ==
          this.removeGroupNameStr(obj.unscramble)
      );
      if (findIndex != -1) {
        let item = this.colorList[findIndex];
        if (item.confidence < obj.confidence) {
          this.colorList[findIndex] = obj;
        }
      } else {
        this.colorList.push(obj);
      }
    } else {
      // 如果是掌形其它数据 在arr没值的情况下才添加
      if (!(isOtherPalmUnscrambles && arr && arr.length)) {
        if (arr) {
          // 查找是否已经存在 如果存在则更新为最高的置信度
          let findIndex = arr.findIndex(
            (item) =>
              this.removeGroupNameStr(item.unscramble) ==
              this.removeGroupNameStr(obj.unscramble)
          );
          if (findIndex != -1) {
            let item = arr[findIndex];
            if (item.confidence < obj.confidence) {
              item.confidence = obj.confidence; // 更新置信度
            }
            item.weight += obj.weight; // 累加权重
          } else {
            arr.push(obj);
          }
        } else {
          this.unscrambleList[i.unscrambleResource] = [obj];
        }
      }
    }
  };

  formatUnscramble(list) {
    if (!list) return "";
    let arr = [];
    list.forEach((i, index) => {
      let confidence =
        i.confidence && i.confidence.length
          ? this.round(i.confidence[0])
          : "";
      arr.push(
        `${index + 1}、${this.formatSerialNumber(
          i.unscramble,
          true
        )}${confidence}`
      );
    });
    return arr.join(" ");
  };

  // 高亮显视(加红)
  addRed(str, confidence) {
    let red = this.isTextRed ? "red" : "";
    return `<span class="${confidence >= this.confidenceProportionRed ? red : ""
      }">${str}</span>`;
  };

  // 合并同置信度的数据
  mergeData(list) {
    let groupList = [];
    list.forEach((i) => {
      let item = groupList.find((j) => j.confidence == i.confidence);
      if (item) {
        item.list.push(i);
      } else {
        groupList.push({
          list: [i],
          confidence: i.confidence,
        });
      }
    });
    groupList.forEach((i) => {
      let str =
        i.list
          .map(
            (j, index) =>
              `${i.list.length > 1 ? this.xh[index] : ""}${this.addRareText(
                j.unscramble
              )}`
          )
          .join("") + this.round(i.confidence, true);
      i.unscrambleStr = this.addRed(str, i.confidence);
    });
    return groupList;
  };

  // 按身体系统分组
  formatBodyGroup(list) {
    let newList = [];
    list.forEach((i) => {
      let strs = /\[(\p{sc=Han}+)\]/gu.exec(i.unscramble);
      let key = strs ? strs[1] : "其他";
      if (strs) i.unscramble = i.unscramble.replace(strs[0], "");
      let arr = [];
      let item = newList.find((item) => item.name == key);
      if (item) {
        item.list.push(i);
      } else {
        newList.push({ name: key, list: [i] });
      }
    });

    newList.forEach((item) => {
      let weight = 0;
      item.list.forEach((i) => {
        this.setUnscrambleStr(i);
        weight += i.weight;
      });
      item.weight = item.name == "其他" ? 0 : weight; //其他不计算权重 后面排序用
      item.list = this.formatGroup(item.list, 1); //删除冲突分组
      item.list = this.mergeData(item.list); //合并同置信度的数据
      this.sortList(item.list);
    });

    // 按权重排序 但名为”其它“的组排在最后
    newList.sort((a, b) => {
      return b.weight - a.weight;
    });

    let newList2 = [];
    newList.forEach((o) => {
      this.addSerialNumber(o.list); //添加序号
      newList2.push(...this.moreGroup(o.list, o.name));
    });
    return newList2;
  };

  // 取出置信度最高于0.66的默认显示 ,其他显示更多里, 如果没有低的则不显高更多按钮, 如果没有高于0.66的而取一条低的默认显视，其它放更多里。
  moreGroup(list, key) {
    let showList = [];
    let moreList = [];
    list.forEach((i) => {
      if (i.confidence >= this.confidenceProportionRed || /稀有\(/.test(i.unscrambleStr)) {
        showList.push(i);
      } else if (this.showMoreList) {
        moreList.push(i);
      }
    });
    if (!showList.length && moreList.length) {
      showList.push(moreList.shift());
    }
    let title = key
      ? `<span class="mk-title"><span>${key}</span></span></br>`
      : "";
    let isShowMore = {
      value: false,
    };
    let showItemList = [
      {
        text: showList
          .map((j, index) => (!index ? title : "") + j.unscrambleStr)
          .join("</br>"),
        showMore: false,
        isShowMore,
        onShowMore: moreList.length
          ? (state) => {
            if (state === undefined) {
              isShowMore.value = !isShowMore.value;
            } else {
              isShowMore.value = state;
            }
          }
          : null,
      },
    ];
    if (moreList.length) {
      showItemList.push({
        text: moreList.map((j) => j.unscrambleStr).join("</br>"),
        showMore: true,
        isShowMore,
      });
    }
    return showItemList;
  };

  // 删除冲突分组如 [A1]和[A2]是冲突组取数据条数多的 如果一样多则取A1。
  formatGroup(list, type) {
    let newList = [];
    let groupList = {};
    list.forEach((i) => {
      let strs = /(\[(\w)(\d)\])/.exec(i.unscrambleStr);
      if (strs) {
        let obj = groupList[strs[2]] || {};
        let arr = obj[strs[3]] || [];
        i.unscramble = i.unscramble.replace(strs[0], "");
        i.unscrambleStr = i.unscrambleStr.replace(strs[0], "");
        arr.push(i);
        obj[strs[3]] = arr;
        groupList[strs[2]] = obj;
      } else {
        newList.push(i);
      }
    });

    for (const key in groupList) {
      let list = [];
      if (Object.hasOwnProperty.call(groupList, key)) {
        const i = groupList[key];
        if (i[1] && i[2]) {
          if (type == 1) {
            //如果是健康类里 则取置信度高的
            let confidence1 = i[1].reduce((num, next) => {
              return next.confidence < num ? num : next.confidence;
            }, 0);
            let confidence2 = i[2].reduce((num, next) => {
              return next.confidence < num ? num : next.confidence;
            }, 0);
            list = confidence1 >= confidence2 ? i[1] : i[2];
          } else {
            list = i[1].length >= i[2].length ? i[1] : i[2];
          }
        } else {
          list = i[1] || i[2];
        }
      }
      newList.push(...list);
    }
    return newList;
  };

  // 按置信度排序
  sortList(list) {
    list.sort((a, b) => b.confidence - a.confidence);
    return list;
  };

  // 添加序号
  addSerialNumber(list) {
    list.forEach((i, index) => {
      i.unscrambleStr = i.unscrambleStr.replace(">", `>${index + 1}、`);
    });
  };

  // 按指定字段对对象数组分组
  groupBy(array, key) {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, {});
  };

  setInfoList() {
    for (const key in this.unscrambleList) {
      if (Object.hasOwnProperty.call(this.unscrambleList, key)) {
        if (key == 1) {
          let list = this.formatBodyGroup(this.unscrambleList[key], key);
          let item = this.infoList2.find((i) => i.id == 1);
          item.value = list;
        } else {
          const i = this.formatGroup(this.unscrambleList[key], key);
          // 排序
          this.unscrambleList[key] = this.sortList(i);
        }
      }
    }

    this.infoList2.forEach((i) => {
      if (this.unscrambleList[i.id]) {
        if (i.id != 1) {
          let list = this.unscrambleList[i.id];
          this.addSerialNumber(list);
          i.value = this.moreGroup(list);
        }
        i.isShow = true;
      } else {
        i.isShow = false;
      }
    });
  };

  // 新版数据整理方法
  setPoint2(handData, obj) {
    this.colorList = [];

    // 收集解读信息
    this.setUnscrambleList(handData.jointWrinkleUnscrambles);

    this.setUnscrambleList(handData.mixUnscrambles);

    handData.handLine.forEach((i) => {
      this.setUnscrambleList(i.unscrambles);
    });

    handData.finger.forEach((i) => {
      this.setUnscrambleList(i.unscrambles);
    });

    handData.nineHillsPlains.forEach((i) => {
      this.setUnscrambleList(i.unscrambles);
      if (i.graphical && i.regionCode != "ALL") {
        obj.graphical.push({
          text: i.regionName || "",
          points: i.graphical.coordinate,
        });

        // 收集纹解读数据
        let item = handData.texture.find((j) =>
          j.nineHillsRegion.includes(i.regionCode)
        );
        if (item) {
          item.regionList = item.regionList || [];
          item.regionList.push({
            regionName: i.regionName,
            textureUnscrambles: i.textureUnscrambles,
          });
        }
      }
    });

    // 掌形其它解读
    this.setUnscrambleList(handData.otherPalmUnscrambles, true);

    this.setInfoList();
    let item = this.infoList2.find((i) => i.id == 1);
    let isShowMore = {
      value: false,
    };
    if (handData.palmColorUnscramble) {
      let red = this.isTextRed ? "red" : "";
      item.value.push({
        text: [
          `<span class="mk-title"><span>掌型颜色解读</span></span>`,
          `<span class="${red}">${handData.palmColorUnscramble.replace(
            /\s*\r*\n\s*/g,
            "</>"
          )}<span>`,
        ].join("</br>"),
        showMore: false,
        isShowMore,
        onShowMore: this.colorList.length
          ? (state) => {
            if (state === undefined) {
              isShowMore.value = !isShowMore.value;
            } else {
              isShowMore.value = state;
            }
          }
          : null,
      });
    }
    if (this.showMoreList) {
      if (this.colorList.length) {
        this.colorList = this.formatGroup(this.colorList); //删除冲突分组
        item.value.push({
          text: this.colorList
            .map((i, index) => index + 1 + "、" + i.unscrambleStr)
            .join("</br>"),
          showMore: true,
          isShowMore,
        });
      }
      if (handData.palmUnscramble) {
        item.value.push({
          text: [
            `<span class="mk-title"><span>掌型:${handData.palmName}</span></span>`,
            handData.palmUnscramble.replace(/\s*\r\n\s*/g, "</br>"),
          ].join("</br>"),
          showMore: false,
        });
      }
    }

    // 纹
    handData.texture.forEach((j) => {
      let str = this.formatUnscramble(j.privateUnscrambles);
      let p = j.graphical.coordinate;
      obj.texture.push({
        text: j.textureName + ": " + str,
        points: [p[0], p[2]],
      });
    });

    // 斑点
    handData.speckle.forEach((j) => {
      let str = this.formatUnscramble(j.privateUnscrambles);
      let p = j.graphical.coordinate;
      obj.speckle.push({
        text: (j.unscramble || j.speckleName) + "：" + str,
        // 获取斑点中心点
        points: [
          p[0][0] + (p[1][0] - p[0][0]) / 2,
          p[0][1] + (p[2][1] - p[1][1]) / 2,
        ],
      });
    });
  };

  // 旧版数据整理方法
  setPoint(list, obj) {
    list.forEach((i) => {
      if (i.graphical) {
        obj.graphical.push({
          text: i.regionName || "",
          points: i.graphical.coordinate,
        });
      }

      // 纹
      if (i.texture) {
        i.texture.forEach((j) => {
          if (
            j.graphical.confidence &&
            j.graphical.confidence[0] >= this.confidenceProportion
          ) {
            let confidence = this.round(j.graphical.confidence[0]);
            if (j.unscramble) {
              this.infoList.push({
                label: i.regionName,
                value: j.unscramble + " " + confidence, //显视置信度数组
                values: [],
              });
            }
            obj.texture.push({
              text: (j.unscramble || j.textureName) + " " + confidence,
              points: j.graphical.coordinate,
            });
          }
        });
      }

      // 斑点
      if (i.speckle) {
        i.speckle.forEach((j) => {
          if (j.unscramble) {
            this.infoList.push({
              label: i.regionName,
              value: j.unscramble,
              values: [],
            });
          }
          let p = j.graphical.coordinate;
          obj.speckle.push({
            text: j.unscramble || j.speckleName,
            // 获取斑点中心点
            points: [
              p[0][0] + (p[1][0] - p[0][0]) / 2,
              p[0][1] + (p[1][1] - p[0][1]) / 2,
            ],
          });
        });
      }

      if (i.subRegion && i.subRegion.length) {
        this.setPoint(i.subRegion, obj, i.regionName);
      }
    });
  };

  toRepeat(list) {
    let newList = [];
    list.forEach((i) => {
      let item = newList.find((j) => j.label == i.label);
      let value = i.value.replace(/^\d+、*/, "");
      if (item) {
        if (!item.values.find((x) => x == i.value) && i.value)
          item.values.push(value);
      } else {
        newList.push({
          label: i.label,
          values: [value],
        });
      }
    });
    newList.forEach((i) => {
      i.values = i.values
        .map((j, index) => {
          return (i.values[index] = `${index + 1}、${j}`);
        })
        .join("<br/>");
    });
    return newList;
  };
};

export default FormatHandData;